import styled from "styled-components";

const ACCENT_PALETTE = [
  { emoji: "🌾", gradient: "linear-gradient(135deg, #31778c 0%, #8b313a 100%)" },
  { emoji: "📦", gradient: "linear-gradient(135deg, #425466 0%, #31778c 100%)" },
  { emoji: "🛒", gradient: "linear-gradient(135deg, #8b313a 0%, #6b252a 100%)" },
  { emoji: "🏷️", gradient: "linear-gradient(135deg, #19bc31 0%, #31778c 100%)" },
];

function hashString(value = "") {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getProductImageAccent(product) {
  const key = product?.id || product?.category || product?.name || "product";
  const index = hashString(String(key)) % ACCENT_PALETTE.length;
  return ACCENT_PALETTE[index];
}

const ImageWrap = styled.div`
  width: 100%;
  aspect-ratio: ${(p) => (p.$variant === "detail" ? "2 / 1" : "4 / 3")};
  max-height: ${(p) => (p.$variant === "detail" ? "240px" : "none")};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.$gradient};
  margin-bottom: ${(p) => p.$marginBottom ?? "1rem"};
  overflow: hidden;
  position: relative;

  @media (max-width: 767px) {
    max-height: ${(p) => (p.$variant === "detail" ? "180px" : "none")};
    aspect-ratio: ${(p) => (p.$variant === "detail" ? "16 / 9" : "4 / 3")};
  }

  .emoji {
    font-size: ${(p) => {
      if (p.$variant === "detail") return "2.75rem";
      if (p.$large) return "2.25rem";
      return "2.25rem";
    }};
    line-height: 1;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  }

  .shine {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.22) 0%,
      transparent 45%,
      rgba(0, 0, 0, 0.06) 100%
    );
    pointer-events: none;
  }
`;

export default function MarketplaceProductImage({
  product,
  large = false,
  variant = "card",
  className = "",
}) {
  const accent = getProductImageAccent(product);
  const resolvedVariant = large ? "detail" : variant;
  const coverUrl =
    product?.coverImage ||
    (typeof product?.media?.[0] === "string"
      ? product.media[0]
      : product?.media?.[0]?.url || product?.media?.[0]?.src) ||
    null;

  return (
    <ImageWrap
      className={className}
      $gradient={accent.gradient}
      $large={large}
      $variant={resolvedVariant}
      $marginBottom={resolvedVariant === "detail" ? 0 : undefined}
      aria-hidden={!coverUrl}
      role={coverUrl ? "img" : undefined}
      aria-label={coverUrl ? product?.name || "Product image" : undefined}
    >
      {coverUrl ? (
        <img
          src={coverUrl}
          alt=""
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <>
          <span className="shine" />
          <span className="emoji">{accent.emoji}</span>
        </>
      )}
    </ImageWrap>
  );
}
